import FieldConditionRule from './FieldConditionRule';
import FieldOption from './FieldOption';
import FieldCondition from './FieldCondition';
import Trigger from './Trigger';
import Utils from '../Services/Utils';
import Attachments from '../Services/api/Attachments';
import SelectOptions from '../Services/SelectOptions';
import { SCORE_OPTIONS, SCORE_OPTIONS_AVERAGE, SCORE_OPTIONS_WITH_MULTIPLIER } from '../Context/DynamicFormContext';
import { VALIDATION_OPTIONS } from '../Components/DynamicFormBuilderScreen/Widgets/Text';
import { fontSizeOptions } from './Section';
import { SCORE_TYPE_AMOUNT, SCORE_TYPE_MULTIPLIER } from '../Context/DynamicFormContext';

export const FIELDS_WITH_SCORE = [
  'checkbox',
  'radio',
  'select',
  'numberInput',
  'currencyInput',
  'sliderRange',
  'starRate',
  'timeInput',
  'ratingScale3pt'
];

export const FIELDS_WITH_MULTIPLIER = [
  'numberInput',
];

export const FIELDS_WITH_AVERAGE = ['checkbox', 'select'];

class Field {
  constructor(item = {}) {
    let scoreOptions = null;
    
    if (FIELDS_WITH_AVERAGE.includes(item.component)) {
      scoreOptions = SCORE_OPTIONS_AVERAGE;
    } else if (FIELDS_WITH_MULTIPLIER.includes(item.component)) {
      scoreOptions = SCORE_OPTIONS_WITH_MULTIPLIER;
    } else {
      scoreOptions = SCORE_OPTIONS;
    }
    const scoreType = !Utils.isNull(item.score_type) ? item.score_type : item.scoreType;
    const fontSize = !Utils.isNull(item.font_size) ? item.font_size : item.fontSize;
    const tags_available = !Utils.isNull(item.tags_available) ?
    item.tags_available.map(tag => !Utils.isNull(tag.value) ? tag.value : tag) : null;
    this.id = item.id || undefined;
    this.index = item.index || 0;
    this.disabled = !Utils.isNull(item.disabled) ? item.disabled : undefined;
    this.description = item.description || undefined;
    this.photo = !Utils.isNull(item.photo) ? item.photo : undefined;
    this.image = !Utils.isNull(item.image) ? item.image : undefined;
    this.notes = !Utils.isNull(item.notes) ? item.notes : undefined;
    this.multiple = !Utils.isNull(item.multiple) ? item.multiple : undefined;
    this.required = !Utils.isNull(item.required) ? item.required : undefined;
    this.placeholder = item.placeholder || undefined;
    this.label = item.label || undefined;
    this.defaultValue = !Utils.isNull(item.defaultValue) ? item.defaultValue : undefined;
    this.display_width = !Utils.isNull(item.display_width) ? item.display_width : undefined;
    this.component = item.component || undefined;
    this.groupId = item.groupId || undefined;
    this.section = item.section || undefined;
    this.validation = !Utils.isNull(item.validation) ?
        (Utils.isNull(item.validation.value) ? SelectOptions.getValue(VALIDATION_OPTIONS, item.validation) : item.validation) :
        { value: '/.*/', label: 'none' };
    this.options = item.options || undefined;
    this.vertical = !Utils.isNull(item.vertical) ? item.vertical : undefined;
    this.compact = !Utils.isNull(item.compact) ? item.compact : undefined;
    this.labelInline = !Utils.isNull(item.labelInline) ? item.labelInline : undefined;
    this.force_line_break = !Utils.isNull(item.force_line_break) ? item.force_line_break : undefined;
    this.inline = !Utils.isNull(item.inline) ? item.inline : undefined;
    this.bold = !Utils.isNull(item.bold) ? item.bold : undefined;
    this.italic = !Utils.isNull(item.italic) ? item.italic : undefined;
    this.fontSize = undefined;
    if (fontSize) {
      this.fontSize = (!fontSize.value ? SelectOptions.getValue(fontSizeOptions(), fontSize.split('px').join('')) : fontSize);
    }
    this.embedded = undefined;
    if (item.embedded) {
      this.embedded = (Array.isArray(item.embedded) ? item.embedded : new Array(item.embedded));
    }
    if (!Utils.isNull(item.group)) {
      this.group = item.group;
    }
    else {
      this.group = item.config ? item.config.group : undefined;
    }
    if (!Utils.isNull(item.subgroup)) {
      this.subgroup = item.subgroup;
    }
    else {
      this.subgroup = item.config ? item.config.subgroup : undefined;
    }
    if (!Utils.isNull(item.field)) {
      this.field = item.field;
    }
    else {
      this.field = item.config ? item.config.field : undefined;
    }
    this.conditions = item.conditions || [];
    this.conditionsRules = item.conditionsRules || [];
    this.numberStars = !Utils.isNull(item.numberStars) ? item.numberStars : undefined;
    this.minValue = !Utils.isNull(item.minValue) ? item.minValue : undefined;
    this.maxValue = !Utils.isNull(item.maxValue) ? item.maxValue : undefined;
    this.minLength = !Utils.isNull(item.minLength) ? item.minLength : undefined;
    this.maxLength = !Utils.isNull(item.maxLength) ? item.maxLength : undefined;
    this.step = !Utils.isNull(item.step) ? item.step : undefined;
    if (FIELDS_WITH_SCORE.includes(item.component)) {
      if (!Utils.isNull(scoreType)) {
        this.scoreType = (Utils.isNull(scoreType.value) ? SelectOptions.getValue(scoreOptions, scoreType) : scoreType);
      }
      else {
        this.scoreType = { value: 0, label: 'No score' };
      }
      if (FIELDS_WITH_MULTIPLIER.includes(item.component)) {
        if (scoreType && scoreType.value === SCORE_TYPE_AMOUNT) {
          this.score = item.score ? item.score : null;
          this.scoreLockDdr = item.scoreLockDdr ? item.scoreLockDdr : false;
        }

        if (scoreType && scoreType.value === SCORE_TYPE_MULTIPLIER) {
          this.multiplierScore = item.multiplierScore ? item.multiplierScore : null;
          this.multiplierScoreLockDdr = item.multiplierScoreLockDdr ? item.multiplierScoreLockDdr : false;
        }
      }
    }
    this.config = item.config || undefined;
    this.triggers = item.triggers || [];
    this.tags_available = tags_available;
    this.originId = item.originId || undefined;
    this.lockDDR = item.lockDDR || undefined;
    this.errors = {};
   
  }

  static parse = async (sectionId, item, fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes) => {
    let scoreOptions = null;

    if (FIELDS_WITH_AVERAGE.includes(item.component)) {
      scoreOptions = SCORE_OPTIONS_AVERAGE;
    } else if (FIELDS_WITH_MULTIPLIER.includes(item.component)) {
      scoreOptions = SCORE_OPTIONS_WITH_MULTIPLIER;
    } else {
      scoreOptions = SCORE_OPTIONS;
    }
    const triggers = (item.triggers || []).map((trigger) => Trigger.parse(item, trigger, chargeCodes));
    const optionList = (item.options || []).map((option) => FieldOption.parse(option));
    const conditionList = (item.conditions || []).map(
      (condition) => FieldCondition.parse(condition, fieldsIdLabelDict, fieldsIdOptionsDict));
    const tags_available = !Utils.isNull(item.tags_available) ?
      item.tags_available.map(tag => !Utils.isNull(tag.value) ? tag.value : tag) : null;
    const conditionRulesValue = item.conditions_rules || item.conditionsRules;
    const conditionRulesList = (conditionRulesValue || []).map(
      (rule) => FieldConditionRule.parse(item, rule, fieldsIdLabelDict, fieldsIdOptionsDict));
    const embedded = Array.isArray(item.embedded) ? item.embedded : new Array(item.embedded);
    const scoreType = !Utils.isNull(item.score_type) ? item.score_type : item.scoreType;
    let scoreTypeValue = undefined;
    if (FIELDS_WITH_SCORE.includes(item.component)) {
      if (!Utils.isNull(scoreType)) {
        scoreTypeValue = (Utils.isNull(scoreType.value) ? SelectOptions.getValue(scoreOptions, scoreType) : scoreType);
      }
      else {
        scoreTypeValue = { value: 0, label: 'No score' };
      }
    }
    let validation = null;
    if (!Utils.isNull(item.validation)) {
      validation = (Utils.isNull(item.validation.value) ? SelectOptions.getValue(VALIDATION_OPTIONS, item.validation) : item.validation);
    }
    else {
      validation = { value: '/.*/', label: 'none' };
    }
    const section = item.section ? item.section : (sectionId || undefined);
    const lockDDR = !Utils.isNull(item.lock_ddr) ? item.lock_ddr : item.lockDDR;
    const fontSize = !Utils.isNull(item.font_size) ? item.font_size : item.fontSize;
    const labelInline = !Utils.isNull(item.label_inline) ? item.label_inline : item.labelInline;
    let fontSizeValue = undefined;
    if (fontSize) {
      fontSizeValue = (!fontSize.value ? SelectOptions.getValue(fontSizeOptions(), fontSize.split('px').join('')) : fontSize);
    }
    let groupValue = undefined;
    if (!Utils.isNull(item.group)) {
      groupValue = item.group;
    }
    else {
      groupValue = (item.config ? item.config.group : undefined);
    }
    let subgroupValue = undefined;
    if (!Utils.isNull(item.subgroup)) {
      subgroupValue = item.subgroup;
    }
    else {
      subgroupValue = (item.config ? item.config.subgroup : undefined);
    }
    let fieldValue = undefined;
    if (!Utils.isNull(item.field)) {
      fieldValue = item.field;
    }
    else {
      fieldValue = (item.config ? item.config.field : undefined);
    }
    const field = {
      id: item.id || undefined,
      index: item.index || 0,
      disabled: !Utils.isNull(item.disabled) ? item.disabled : undefined,
      description: item.description || undefined,
      photo: !Utils.isNull(item.photo) ? item.photo : undefined,
      image: !Utils.isNull(item.image) ? item.image : undefined,
      notes: !Utils.isNull(item.notes) ? item.notes : undefined,
      multiple: !Utils.isNull(item.multiple) ? item.multiple : undefined,
      required: !Utils.isNull(item.required) ? item.required : undefined,
      placeholder: item.placeholder || undefined,
      label: item.label || undefined,
      defaultValue: !Utils.isNull(item.defaultValue) ? item.defaultValue : undefined,
      display_width: !Utils.isNull(item.display_width) ? item.display_width : undefined,
      component: item.component || undefined,
      groupId: item.groupId || undefined,
      section: section,
      validation: validation,
      options: optionList.length > 0 ? optionList : undefined,
      vertical: !Utils.isNull(item.vertical) ? item.vertical : undefined,
      compact: !Utils.isNull(item.compact) ? item.compact : undefined,
      labelInline: !Utils.isNull(labelInline) ? labelInline : undefined,
      force_line_break: !Utils.isNull(item.force_line_break) ? item.force_line_break : undefined,
      inline: !Utils.isNull(item.inline) ? item.inline : undefined,
      bold: !Utils.isNull(item.bold) ? item.bold : undefined,
      italic: !Utils.isNull(item.italic) ? item.italic : undefined,
      fontSize: fontSizeValue,
      embedded: embedded || undefined,
      group: groupValue,
      subgroup: subgroupValue,
      field: fieldValue,
      conditions: conditionList,
      conditionsRules: conditionRulesList,
      numberStars: !Utils.isNull(item.numberStars) ? item.numberStars : undefined,
      minValue: !Utils.isNull(item.minValue) ? item.minValue : undefined,
      maxValue: !Utils.isNull(item.maxValue) ? item.maxValue : undefined,
      minLength: !Utils.isNull(item.minLength) ? item.minLength : undefined,
      maxLength: !Utils.isNull(item.maxLength) ? item.maxLength : undefined,
      step: !Utils.isNull(item.step) ? item.step : undefined,
      scoreType: scoreTypeValue,
      config: item.config || undefined,
      originId: item.originId || undefined,
      lockDDR: lockDDR || undefined,
      triggers: triggers,
      tags_available: tags_available,
    };

    if (FIELDS_WITH_MULTIPLIER.includes(item.component)) {
      if (scoreTypeValue && scoreTypeValue.value === SCORE_TYPE_AMOUNT) {
        field.score = item.score ? item.score : null;
        field.scoreLockDdr = item.scoreLockDdr ? item.scoreLockDdr : false;
      }

      if (scoreTypeValue && scoreTypeValue.value === SCORE_TYPE_MULTIPLIER){
        field.multiplierScore = item.multiplierScore ? item.multiplierScore : null;
        field.multiplierScoreLockDdr = item.multiplierScoreLockDdr ? item.multiplierScoreLockDdr : false;
      }
    }

    return new Field(field);
  };

  serialize = (sectionLabel, builder) => {
    const triggers = (this.triggers || []).map(item => item.serialize());
    const optionList = (this.options || []).map(item => new FieldOption(item).serialize());
    const conditions = (this.conditions || []).map(item => item.serialize());
    const conditionsRules = (this.conditionsRules || []).map(item => item.serialize());
    const groupId = !builder ? this.groupId : Utils.generateGroupId(sectionLabel, this.section, this.id);
    const config = this.field ? {field: this.field} : null;
    if (config && !Utils.isNull(this.group)) {
      config.group = this.group;
    }
    if (config && !Utils.isNull(this.subgroup)) {
      config.subgroup = this.subgroup;
    }
    let defaultValue = undefined;
    if (Array.isArray(this.defaultValue)) {
      defaultValue = this.defaultValue.map((value) => !Utils.isNull(value) && !Utils.isNull(value.value) ? value.value : value);
    }
    else {
      defaultValue = ((this.defaultValue && this.defaultValue.value) ? this.defaultValue.value : this.defaultValue);
    }
    let display_width = undefined;
    if (Array.isArray(this.display_width)) {
      display_width = this.display_width.map((value) => !Utils.isNull(value) && !Utils.isNull(value.value) ? value.value : value);
    }
    else {
      display_width = ((this.display_width && this.display_width.value) ? this.display_width.value : this.display_width);
    }
    const field = {
      id: this.id,
      index: this.index,
      description: this.description,
      photo: this.photo,
      image: this.image,
      notes: this.notes,
      multiple: this.multiple,
      required: this.required,
      placeholder: this.placeholder,
      label: this.label,
      defaultValue: defaultValue ,
      display_width: display_width || undefined,
      component: this.component,
      groupId: groupId || undefined,
      section: this.section,
      validation: !Utils.isNull(this.validation) && !Utils.isNull(this.validation.value) ? this.validation.value : this.validation,
      options: optionList,
      vertical: this.vertical,
      compact: this.compact,
      label_inline: this.labelInline,
      force_line_break: this.force_line_break,
      inline: this.inline,
      bold: this.bold,
      italic: this.italic,
      font_size: this.fontSize ? this.fontSize.label : undefined,
      conditions: conditions,
      conditions_rules: conditionsRules,
      numberStars: this.numberStars,
      minValue: this.minValue,
      maxValue: this.maxValue,
      minLength: this.minLength,
      maxLength: this.maxLength,
      step: this.step,
      score_type: !Utils.isNull(this.scoreType) && !Utils.isNull(this.scoreType.value) ? this.scoreType.value : this.scoreType,
      config: config || undefined,
      triggers: triggers,
      embedded: this.embedded || undefined,
      originId: builder ? undefined : this.originId || undefined,
      lock_ddr: this.lockDDR || undefined,
      tags_available: this.tags_available || [],
    };
    
    if (FIELDS_WITH_MULTIPLIER.includes(this.component)) {
      if (this.scoreType && this.scoreType.value === SCORE_TYPE_AMOUNT) {
        field.score = this.score ? this.score : null;
        field.scoreLockDdr = this.scoreLockDdr ? this.scoreLockDdr : false;
      }

      if (this.scoreType && this.scoreType.value === SCORE_TYPE_MULTIPLIER){
        field.multiplierScore = this.multiplierScore ? this.multiplierScore : null;
        field.multiplierScoreLockDdr = this.multiplierScoreLockDdr ? this.multiplierScoreLockDdr : false;
      }
    }

    return field;
  }

  serializeAsync = async (sectionLabel, builder) => {
    const data = this.serialize(sectionLabel, builder);
    let embeddedID = null;
    if (this.embedded && this.embedded.length > 0) {
      embeddedID = this.embedded[0]?.id;
    }
    const embedded = (!embeddedID && this.embedded && this.embedded.length > 0) ? await Attachments.create(this.embedded) : this.embedded;
    data.embedded = embedded || undefined;
    return data;
  }

  changeValue(field, value) {
    this[field] = value;
  }

  changeValues(values) {
    for (const field in values) {
      this[field] = values[field];
    }
  }

}

export default Field;
